import { lazy, Suspense } from "react";
import CabifyBanner from "../cabifyClone/CabifyBanner";
import CabifyChoose from "../cabifyClone/CabifyChoose";

const ShuttleAppreciation = lazy(() => import("../../shuttle_software/ShuttleAppreciation"));
const TaxiFaq = lazy(() => import("../../taxiDispatchSoftware/TaxiFaq"));
const CabifyFeature = lazy(() => import("../cabifyClone/CabifyFeature"));
const CabifyFeatureTwo = lazy(() => import("../cabifyClone/CabifyFeatureTwo"));
const CabifyMinimum = lazy(() => import("../cabifyClone/CabifyMinimum"));
const CabifyPlace = lazy(() => import("../cabifyClone/CabifyPlace"));
const CabifySupport = lazy(() => import("../cabifyClone/CabifySupport"));

const bannerData = {
  title: "Launch a Taxi Service with Mai Linh Clone App",
  description: "Mobility Infotech brings you a ready-to-deploy Mai Linh Clone App—the ultimate ride-hailing and carpooling platform tailored for Vietnam’s growing mobility market. Experience a seamless, branded launch with advanced features, intuitive design, and unmatched scalability for your transportation business.",
  image: "/assets/home/cabify-banner.webp",
  btn: "get free demo",
  breadcrumbData: {
    newClass: "white-breadcrumb",
    list: [
      {
        page: "Home",
        slug: "/"
      },
      {
        page: "Mai Linh Clone App",
        slug: ""
      },
    ]
  }
};

const chooseData = {
  titlepart1: "Why Choose Our ",
  titlepart2: "Mai Linh Clone",
  titlepart3: "Script?",
  description: "Mobility Infotech’s Mai Linh Clone App is an end-to-end ride-hailing solution designed to get your business off the ground fast. Featuring real-time GPS tracking, secure payment options, and an intuitive user interface for passengers, drivers, and admins, this robust system is engineered for growth and adaptability in the Vietnamese market.",
  pointer1: "Rapid Market Launch",
  pointer2: "User-Centric Experience",
  pointer3: "Feature-Rich Framework",
  pointer4: "Timely Delivery Commitment",
  pointer5: "White-Labeled Solution",
  pointer6: "Full Brand Control",
  pointer7: "Integrated Payment Systems",
  pointer8: "Fully Customizable Platform",
  pointer9: "Cost-Efficient Build",
  image: "/assets/home/cabify-choose.webp",
  backImage: "/assets/home/cabify-choose-back.webp",
};

const featureData = {
  titlePart1: "Feature Suite for Riders",
  titlePart2: "Drivers & Admins",

  feature1: {
    image: "/assets/home/cabify-feature-1.webp",
    title1: "Instant Fare Details",
    description1: "Accurate cost prediction based on distance, traffic, and real-time factors.",
    title2: "Emergency SOS Alerts",
    description2: "Safety comes first with real-time emergency contact access.",
    title3: "Ratings & Reviews",
    description3: "Two-way feedback for service quality enhancement.",
    title4: "Smooth Profile Setup",
    description4: "Easy sign-up via email or mobile number.",
    title5: "Live Location Tracking",
    description5: "View driver location and trip route in real time.",
    title6: "Vehicle Selection",
    description6: "Choose economy, premium, or pool rides.",
    title7: "Smart Trip History",
    description7: "Access ride logs, receipts, and trip summaries.",
    title8: "Multi-Stop Rides",
    description8: "Add extra stops with ease during a single ride.",
  },

  feature2: {
    image: "/assets/home/cabify-feature-2.webp",
    title1: "Trip Request Management",
    description1: "Accept or decline ride requests instantly.",
    title2: "Route Navigation & Optimization",
    description2: "Integrated GPS for efficient navigation and fuel savings.",
    title3: "Earnings & Trip Summary",
    description3: "Monitor daily, weekly, and monthly earnings.",
    title4: "Driver Profile & Document Upload",
    description4: "Upload and manage licenses, registration, and IDs.",
    title5: "Availability Toggle",
    description5: "Switch online/offline in real-time.",
    title6: "Push Notifications",
    description6: "Alerts for trip requests, payments, reviews, and more.",
    title7: "Built-in SOS Function",
    description7: "Emergency support at the tap of a button.",
    title8: "Rider Communication",
    description8: "Secure chat or call functionality with riders.",
  },

  feature3: {
    image: "/assets/home/cabify-feature-3.webp",
    title1: "Comprehensive Dashboard",
    description1: "Full analytics view including trips, users, and revenue.",
    title2: "User & Driver Management",
    description2: "Verify accounts, manage ratings, and handle documents.",
    title3: "Real-Time Trip Monitoring",
    description3: "Real-time tracking of active trips with status details.",
    title4: "Category & Fare Control",
    description4: "Adjust base fare, surge pricing, and ride categories.",
    title5: "Commission & Payout Tools",
    description5: "Set commission rates and streamline payouts.",
    title6: "Advanced Reporting",
    description6: "Export data on revenue, trips, and user behavior.",
    title7: "Marketing Campaign Tools",
    description7: "Design and manage promo codes, offers, and bonuses.",
    title8: "Ride Dispute Resolution",
    description8: "Efficient complaint and issue handling.",
  },
}

const featureTwoData = {
  titlePart1: "Highlighting the",
  titlePart2: "top features",
  btn: "More features",
  rider: {
    image1: "/assets/home/lyft-feature-rider1.webp",
    title1: "Smarter Rides, Better Comfort",
    description1: "From upfront fare estimates to multiple ways to pay, we’ve made every feature easy, efficient, and built around your ride comfort.",
    image2: "/assets/home/lyft-feature-rider2.webp",
    title2: "Get estimated trip cost",
    description2: "Know the price upfront based on traffic and route conditions.",
    image3: "/assets/home/lyft-feature-rider3.webp",
    title3: "Contact the driver",
    description3: "Track your ride in real-time and receive arrival alerts.",
    image4: "/assets/home/lyft-feature-rider4.webp",
    title4: "Use multiple payment options",
    description4: "Pay via card, local e-wallets, or bank transfers.",
  },
  driver: {
    image1: "/assets/home/lyft-feature-driver1.webp",
    title1: "Add payout account",
    description1: "Link multiple payout accounts with secure transfers.",

    image2: "/assets/home/lyft-feature-driver2.webp",
    title2: "Cancel the trip",
    description2: "Cancel rides with a single tap when necessary.",

    image3: "/assets/home/lyft-feature-driver3.webp",
    title3: "View earnings",
    description3: "View income reports with detailed breakdowns.",

    image4: "/assets/home/lyft-feature-driver4.webp",
    title4: "View trip details",
    description4: "Full details on completed rides for easy reference.",

    image5: "/assets/home/lyft-feature-driver5.webp",
    title5: "Add toll charges",
    description5: "Add tolls automatically for accurate fare computation.",
  },

  admin: {
    image1: "/assets/home/zip-feature-1.webp",
    title1: "Data Analytics",
    description1: "Data-driven insights to refine operations.",

    image2: "/assets/home/zip-feature-admin-2.webp",
    title2: "Set Pricing",
    description2: "Create pricing strategies based on region, time, and demand.",

    image3: "/assets/home/zip-feature-admin-3.webp",
    title3: "Fleet Management",
    description3: "Track vehicle status, manage driver activities, and schedule maintenance.",

    image4: "/assets/home/zip-feature-admin-4.webp",
    title4: "Payment Management",
    description4: "Monitor transactions, resolve payment issues, and execute payouts.",

    image5: "/assets/home/zip-feature-admin-5.webp",
    title5: "Discount & Promotions",
    description5: "Launch and manage targeted user offers and referral bonuses.",
  },

  fleet: {
    image1: "/assets/home/zip-feature-2.webp",
    title1: "Customer Management",
    description1: "View rider history, feedback, and profiles.",

    image2: "/assets/home/zip-feature-fleet-2.webp",
    title2: "Cars Management",
    description2: "Add or retire cars, monitor availability and performance.",

    image3: "/assets/home/zip-feature-fleet-3.webp",
    title3: "Documentation Management",
    description3: "Upload and verify all necessary legal documents.",

    image4: "/assets/home/zip-feature-fleet-4.webp",
    title4: "Car Maintenance",
    description4: "Plan and track regular servicing and repairs.",

    image5: "/assets/home/zip-feature-fleet-5.webp",
    title5: "Dynamic Pricing",
    description5: "Auto-adjust pricing based on market demand and peak times.",
  },
}

const cabifyPlaceData = {
  titlePart1: "Manage your business,",
  titlePart2: "in one place",
  btn: "more features",
  tab1: {
    title: "Central Dashboard",
    description: "View operations, metrics, and user trends at a glance.",
    image: "/assets/home/lyft-place-1.webp",
  },
  tab2: {
    title: "App-Wide Configuration",
    description: "Tailor site settings, roles, and features to your needs.",
    image: "/assets/home/lyft-place-2.webp",
  },
  tab3: {
    title: "Vehicle Category Management",
    description: "Add or adjust vehicle types and fare settings.",
    image: "/assets/home/lyft-place-3.webp",
  },
  tab4: {
    title: "Full site configuration options",
    description: "Fine-tune backend functionalities, user roles, payment gateways, and app behavior through comprehensive configuration tools.",
    image: "/assets/home/lyft-place-4.webp",
  },
  tab5: {
    title: "Cancellation Policy Customization",
    description: "Define reasons and protocols for trip cancellations.",
    image: "/assets/home/lyft-place-5.webp",
  },
  tab6: {
    title: "Custom Fare Rules",
    description: "Manage base fares, surge models, and location-based pricing.",
    image: "/assets/home/lyft-place-6.webp",
  },
  tab7: {
    title: "Payout Control Panel",
    description: "Configure payout cycles, linked accounts, and payment logs.",
    image: "/assets/home/lyft-place-7.webp",
  },
  tab8: {
    title: "Promo Campaign Builder",
    description: "Design and deploy discounts, coupons, and seasonal campaigns.",
    image: "/assets/home/lyft-place-8.webp",
  },
}

const cabifyMinimumData = {
  tagline: "Why Quality Outshines Cost",
  titlePart1: "Build Beyond",
  titlePart2: "a Basic MVP",
  description: "Launch your ride-hailing app with Mobility Infotech’s Mai Linh Clone, developed for scale, performance, and long-term success.",
  box1: {
    image: "/assets/home/lyft-minimum-1.webp",
    title: "Full Ownership",
  },
  box2: {
    image: "/assets/home/lyft-minimum-2.webp",
    title: "All Premium Features Included",
  },
  box3: {
    image: "/assets/home/lyft-minimum-3.webp",
    title: "Unlimited Free Updates",
  },
  box4: {
    image: "/assets/home/lyft-minimum-4.webp",
    title: "Elegant UI/UX Design",
  },
  box5: {
    image: "/assets/home/lyft-minimum-5.webp",
    title: "Dedicated Support",
  },
  box6: {
    image: "/assets/home/lyft-minimum-6.webp",
    title: "High Performance and Reliability",
  },
  btn: "SEE OUR PRICING PLAN",
}

const cabifySupportData = {
  titlePart1: "Free support, no",
  titlePart2: "additional charge",
  box1: {
    image: "/assets/home/lyft-support-1.webp",
    title: "White-labeling",
    description: "Your logo, brand colors, and app name across all platforms.",
  },
  box2: {
    image: "/assets/home/lyft-support-2.webp",
    title: "Server installation",
    description: "Installation on your server of choice.",
  },
  box3: {
    image: "/assets/home/lyft-support-3.webp",
    title: "App Store Submission",
    description: "Guidance and execution for Android & iOS listing.",
  },
  box4: {
    image: "/assets/home/lyft-support-4.webp",
    title: "App rejection support",
    description: "Hands-on support for resolving review issues.",
  },
}

const faqData = [
  {
    id: "0",
    question: "01. What is the Mai Linh Clone App by Mobility Infotech?",
    answer: "It’s a ready-to-launch, fully customizable ride-hailing and carpooling app designed to accelerate your entry into the Vietnamese mobility sector. It includes rider, driver, admin, and fleet management features.",
  },
  {
    id: "1",
    question: "02. Can I brand this app under my company name?",
    answer: "Yes. The app is fully white-labeled to reflect your brand identity, logo, colors, and business name.",
  },
  {
    id: "2",
    question: "03. What platforms are supported?",
    answer: "The app supports both Android and iOS, with an advanced web-based admin panel.",
  },
  {
    id: "3",
    question: "04. How long does it take to launch the app?",
    answer: "Our turnkey Cabify Clone App can be deployed in record time. With all configurations in place, your branded app can go live within just a few days, depending on custom requirements.",
  },
  {
    id: "4",
    question: "05. Is post-launch support available?",
    answer: "Yes. We offer maintenance, bug fixes, technical updates, and customer support after deployment.",
  },
  {
    id: "5",
    question: "06. What type of businesses can use this app?",
    answer: "This app is ideal for taxi services, carpooling businesses, fleet management providers, and entrepreneurs looking to enter the mobility-as-a-service industry.",
  },
];

export default function MaiLinhClone() {
  return (
    <>
      <CabifyBanner data={bannerData} />
      <CabifyChoose data={chooseData} />

      <Suspense fallback={null}>
        <CabifyFeature data={featureData} />
        <CabifyFeatureTwo data={featureTwoData} />
        <CabifyPlace data={cabifyPlaceData} />
        <CabifyMinimum data={cabifyMinimumData} />
        <CabifySupport data={cabifySupportData} />
        <ShuttleAppreciation />
        <div className="zip-faq-fixer">
          <TaxiFaq faqData={faqData} />
        </div>
      </Suspense>
    </>
  )
}
